export const LOADING = 'LOADING'
export const GET_BASIC_USER_INFO = 'GET_BASIC_USER_INFO'
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const CREATE_TUG_AUDIT = 'CREATE_TUG_AUDIT'
